/* eslint-disable */
import {SaleStatus} from './SaleStatus';
export enum StockStatus {
	NotDefined = 0,
	Storage = 1,
	Order = 2,
	Create = 3,
	End = 4,
	
}
export enum Time {
	NotDefined = 0,
	TwoToThreeWorkDays = 1,
	TwoToFiveWorkDays = 2,
	ThreeToFiveWorkDays = 3,
	FiveToTenWorkDays = 4,
	TwoToFourWeeks = 5,
	FourToSixWeeks = 6,
	SixToEightWeeks = 7,
	EightToTenWeeks = 8,
	TenToTwelveWeeks = 9,
	TwelveToFourteenWeeks = 10,
	FourteenToSixteenWeeks = 11,
	TwoToThreeWeeks = 12,
	ThreeToFourWeeks = 13,
	FourToSevenWorkDays = 14,
	
}
export enum CarriageMethod {
	NotDefined = 0,
	Home = 1,
	Away = 2,
	Special = 3,
	HomeSpecial = 4,
	AwaySpecial = 5,
	HomeDeliveryOptions = 6,
	AwayDeliveryOptions = 7,
	Letter = 8,
	
}
/**
* @description Interface for Avensia.Commerce.Web.src.components.Product.ProductMeta
*/
export interface ProductMeta {
	showDeliveryInfo: boolean;
	showServiceChargeInfo: boolean;
	stockStatus: StockStatus;
	saleStatus: SaleStatus;
	deliveryEstimate: Time;
	supplierProductNumber: string;
	publishedSaleDate: string;
	stock: string;
	isInStock: boolean;
	isLowInStock: boolean;
	isBackOrder?: boolean;
	backInStockDate?: Date;
}
/**
* @description Interface for Avensia.Commerce.Web.src.components.Product.ProductDetailedMeta
*/
export interface ProductDetailedMeta extends ProductMeta {
	carriageMethod: CarriageMethod;
	deliveryCost: string;
	deliveryCostAmount: number;
	excludeFromFeed: boolean;
	mandatoryAddonService: boolean;
	campaignEnd: string;
}
